const base64toBlob = (base64src) => fetch(base64src).then((res) => res.blob());

export default base64toBlob;
